/**
 * @file
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-6 RFC 9110 6 Message Abstraction}
 */

import {
  FieldName,
  FieldSection,
  FieldType,
  dateFieldValueFormat,
  fieldNameValueFormat,
  listFieldFormat,
  singleFieldFormat,
} from "./fields";
import { Method } from "./methods";
import { Status } from "./status";

/**
 * Date
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-6.6.1 RFC 9110 6.6.1 Date}
 */
export const DateField = new FieldType(
  new FieldName("Date"),
  singleFieldFormat(dateFieldValueFormat),
);

/**
 * Trailer
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-6.6.2 RFC 9110 6.6.2 Trailer}
 */
export const TrailerField = new FieldType(
  new FieldName("Trailer"),
  listFieldFormat(fieldNameValueFormat),
);

export class Request {
  constructor({
    method,
    target,
    headers = new FieldSection(),
    content = new ArrayBuffer(0),
    trailers = new FieldSection(),
  }: {
    method: Method;
    target: string;
    headers?: FieldSection;
    content?: ArrayBuffer;
    trailers?: FieldSection;
  }) {
    this.method = method;
    this.target = target;
    this.headers = headers;
    this.content = content;
    this.trailers = trailers;
  }

  readonly method: Method;
  readonly target: string;
  readonly headers: FieldSection;
  readonly content: ArrayBuffer;
  readonly trailers: FieldSection;
}

export class Response {
  constructor({
    status,
    headers = new FieldSection(),
    content = new ArrayBuffer(0),
    trailers = new FieldSection(),
  }: {
    status: Status;
    headers?: FieldSection;
    content?: ArrayBuffer;
    trailers?: FieldSection;
  }) {
    this.status = status;
    this.headers = headers;
    this.content = content;
    this.trailers = trailers;
  }

  readonly status: Status;
  readonly headers: FieldSection;
  readonly content: ArrayBuffer;
  readonly trailers: FieldSection;
}
